module.exports = __webpack_public_path__ + "img/chair.745327ee.svg";